import React from 'react';
import styles from '../styles';
import Avatar from './Avatar';
import SocialRow from './SocialRow';
import ProjectsList from './ProjectsList';
import InteractiveButton from './InteractiveButton';
import theme from '../theme';

function CardProfileComponent({
	profile,
	contact,
	labels,
	socials,
	projects,
	cv,
	avatarSize,
	nameFontSize,
	subtitleFontSize,
	projectsTitleSize,
	linkFontSize,
	linkPadding,
	linkRadius,
	socialIconSize,
	socialGap
}) {
	return (
		<div style={theme.card} className="app-container">
                
                <div style={{ textAlign: 'center', marginBottom: 0 }}>
                    {/* Avatar encima del nombre (componente) */}
                    <Avatar profile={profile} size={avatarSize} />

                    {profile.name && <h1 style={{ ...styles.name, fontSize: nameFontSize }}>{profile.name}</h1>}
                    {profile.subtitle && <div style={{ ...styles.subtitle, fontSize: subtitleFontSize }}>{profile.subtitle}</div>}

                    <SocialRow
                        socials={socials}
                        email={contact.email}
                        emailLabel={contact.emailLabel}
                        ariaLabel={labels.socials}
                        socialIconSize={socialIconSize}
                        socialGap={socialGap}
                        isExtraSmall={false}
                    />
                </div>

                <div>
                    {labels.projectsTitle && <h2 style={{ ...styles.projectsTitle, fontSize: projectsTitleSize }}>{labels.projectsTitle}</h2>}

                    <div className="projects-links">
                        {projects && projects.length > 0 ? (
                            <ProjectsList
                                projects={projects}
                                linkFontSize={linkFontSize}
                                linkPadding={linkPadding}
                                linkRadius={linkRadius}
                            />
                        ) : (
                            <p style={styles.smallDisabled}>{labels.emptyProjects}</p>
                        )}
                    </div>
                </div>

                <div style={{ marginTop: 6, textAlign: 'center' }}>
                    <InteractiveButton
                        href={cv.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ ...styles.cv, fontSize: linkFontSize, padding: linkPadding, borderRadius: linkRadius }}
                        ariaLabel={labels.cv}
                    >
                        {cv.label}
                    </InteractiveButton>
                </div>
            </div>
	);
}

export default CardProfileComponent;
